import React, { useEffect } from 'react';
import { useMsal, useMsalAuthentication } from '@azure/msal-react';
import {
    InteractionRequiredAuthError,
    InteractionStatus,
    InteractionType,
    RedirectRequest,
    SilentRequest
} from '@azure/msal-browser';
import { useHistory } from 'react-router-dom';

const graphScopes = ['openid', 'email', 'offline_access', 'profile', 'User.Read']

export interface LoginbackProps {
    returnUrl?: string;
}

// Trigger login
const Login: React.FC<LoginbackProps> = ({returnUrl}) => {
    const { accounts, inProgress } = useMsal();
    const history = useHistory();

    // Get the return URL from the query string
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    returnUrl = returnUrl == null ? urlParams.get('returnUrl') ?? '/' : returnUrl;

    const silentRequest: SilentRequest = {
        scopes: graphScopes,
        account: accounts[0],
    };

    const redirectRequest: RedirectRequest = {
        scopes: graphScopes,
    };

    const {login, error} = useMsalAuthentication(InteractionType.Silent, silentRequest);

    useEffect(() => {
        if(inProgress !== InteractionStatus.None) return;

        if (!accounts.length || (error && error instanceof InteractionRequiredAuthError)) {
            login(InteractionType.Redirect, redirectRequest).then(
              () => {
                  // Login successful, redirect to returnUrl
                  history.push(`/callback/?returnUrl=${returnUrl}`);
              }
            );
        }
    }, [error, login]);

    return <></>;
};

export default Login;
